<app-theme-night *ngIf="isNightTheme$ | async"></app-theme-night>
<app-toolbar #toolbarResize waResizeObserver></app-toolbar>
<app-main-content></app-main-content>
